import classNames from 'classnames'
import { pick } from 'lodash-es'
import Image from 'next/image'

export default function OfficeLine ({
  data,
  bgColor,
  iconWidth = 200,
  iconHeight = 20,
  center = false,
  className
}) {

  const office = pick(data || {}, ['icon', 'name', 'address'])
  const icon = office.icon
  const alt = office.address || office.name
  const style = icon ? {backgroundColor: bgColor} : null
  return (
    <div className={classNames('h-40 flex items-center px-10', {'bg-neutral-1': !icon, 'justify-center': center}, className)} style={style}>
      {
        icon
        ? <Image src={icon} alt={alt} className={classNames('object-contain', center ? 'object-center' : 'object-left')} width={iconWidth} height={iconHeight}></Image>
        : <i className='icon icon-offices text-neutral-5 !text-1xl'></i>
      }
    </div>
  )
}
